<template>
  <div class="enquiry-wrap">
      <div class="enquiry">
          <div class="enquiry-header" v-if="Data.action_pic">
              <img :src="Data.action_pic" alt="">
          </div>
          <div class="enquiry-content">
              <div class="content-from">
                    <div class="username item ">
                        <div class="title">姓名<span>*</span></div>
                        <div class="input-item">
                            <input v-model="name"  type="text" placeholder="请输入姓名">
                            
                        </div>
                        <span class="validata" v-if="isValidataName">姓名不能为空！</span>
                    </div>
                    <div class="phone item">
                        <div class="title">电话<span>*</span></div>
                        <div class="input-item">
                            <input v-model="phone"  type="text" placeholder="请输入电话">
                            
                        </div>
                        <span class="validata" v-if="isValidataPhone">手机号不能为空！</span>
                    </div>
                    <div class="cartypes item">
                        <div class="title">意向车型<span>*</span></div>
                        <el-select v-model="carType" placeholder="请选择意向车型">
                            <el-option>请选择意向车型</el-option>
                            <el-option v-for="(item,index) in carTypes" :key="index" :label="item" :value="item">
                            </el-option>
                        </el-select>       
                    </div>
                    <div class="submit">
                        <el-button @click="onSubmit">立享钜惠底价</el-button>
                    </div>
              </div>
             <div v-show="isShowName" class="content-name">
                  <NameList :list='Data.baoming_logs'></NameList>
              </div>
              <div v-show="!isShowName">
                  <ImageInfo :images='Data.pic_text'></ImageInfo>
              </div> 

          </div>
          
      </div>
      <div class="enquiry-footer">
              <div class="btn-wrap">
                  <el-button v-if="Data.pic_text.length >0" @click="changePage" type="primary">{{isShowName?'查看详情':'一键立享专属购车底价'}}</el-button>
                 
                  <!--<el-button class="gohome"  @click="$router.push(`/gocat`)" type="primary">返回GO车惠</el-button> -->
              </div>
              <div class="statement">
                  提交即视为您已阅读并同意
                  <span @click="dialogVisible = true">《个人信息保护声明》</span>
              </div>
               <el-dialog
                    :visible.sync="dialogVisible"
                    :modal-append-to-body="false"
                    :show-close="false"
                    >
                    <div class="dialog-header">个人信息授权与保护声明</div>
                    <div class="dialog-content">
                        <p>我们/公司非常重视用户信息的保护。您在使用我们的相关服务（以下简称“服务”），并在相应页面填写个人信息前， 请您务必仔细阅读本声明。您一旦主动在页面填写您的个人信息并进行提交操作，即意味着您同意我们按照本声明收集、 使用、共享您的相关信息。</p>
                        <h3>一、个人信息的收集</h3>
                        <p>1、我们提供服务时，可能会收集下列与您有关的个人信息：</p>
                        <p>您在本页面所涉及的表单中输入/选择的信息包括：姓名、手机号。请您注意，具体需要填写的信息可能会根据我们提供的产品/ 服务的不同而有所差异，请以届时向您展示的服务以及所对应的要求填写相关个人信息，但我们会在下文向您说明相关个人信息的收集和使用规则。</p>
                        <p>2、您需要注意的是，以上个人信息均是您自愿提供。您有权拒绝提供，但可能无法正常使用相应的服务、功能或者无法达到服务拟达到的效果。</p>
                        <p>3、对于不满 18 岁的用户，须在其监护人陪同未成年人用户已经阅读和理解本声明并且许可的情况下向我们提交相关个人信息。</p>
                        <h3>二、个人信息的使用和共享</h3>
                        <p>1、您同意，我们可以通过以下方式对个人信息进行使用和共享：</p>
                        <p>（1）我们收集您的姓名、手机号用于及时与您取得联系，并通过人工或语音机器人的方式与您沟通产品或服务的相关事宜。</p>
                        <p>（2）如您拟撤回授权/删除您提交的个人信息的，您可以与我们联系，我们将尽快配合处理。</p>
                        <p>2、为了实现上述目的，我们可能会将您的必要信息共享给我们的技术合作伙伴（例如语音机器人服务提供商），并由其在服务范围内进行合法、正当、必要地使用和处理。</p>
                        <p>3、我们将严格保护您的个人信息安全。我们将采用适当制度、安全技术和程序等措施来保护您的个人信息不被未经授权的访问、使用或泄漏。</p>
                        <h3>三、适用法律</h3>
                        <p>1、本声明适用中华人民共和国法律。</p>
                        <p>2、如果您需要查询、修改或更正您的个人信息，或对个人信息保护问题有任何疑问或投诉，您可以与我们联系，我们将尽快配合处理。</p>
                        <h3>四、变更</h3>
                        <p>我们会适时对本声明进行修订，该等修订构成本声明的一部分。公司会将修改后的声明予以发布。在该种情况下，若您继续使用我们的服务，即表示同意接受经修订的声明的约束。</p>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="dialogVisible = false">我已阅读</el-button>
                    </div>

                </el-dialog>
        </div>
       
  </div>
</template>

<script>
import NameList from '@/components/NameList/NameList';
import ImageInfo from '@/components/ImageInfo/ImageInfo'

export default {
    name:"Enquiry",
    components:{
        NameList,
        ImageInfo
    },
    data(){
        return{
            dialogVisible: false,
            initId: '',
            carTypeById: '',
            Data:[],
            visible: false,
            chexing:'',
            options: [
                '8888','7777','6666','5555','4444','3333','2222','1111'
            ],
            isShowName:true,
            carTypes: [], //车类型的数组
            carType: '', //车类型名称
            phone:'',
            name:'',
            isValidataName:false,
            isValidataPhone:false
        }
    },
    methods:{
        handleClose(done) {
            this.$confirm('确认关闭？')
            
        },
        //更换页面
        changePage(){
            this.isShowName = !this.isShowName;
        },
         //获取购车惠详情数据
        getActionInfoData(result) {
            if (result.code === 200) {
                this.Data = result.data;
                this.dealerList = result.data.shop;
                this.brand = result.data.brand.brand_name;
                result.data.car_list.forEach((carItem) => {
                    this.carTypes.push(carItem.car_name)
                })
                this.carType = this.carTypes[0];
                this.carList = result.data.car_list;
               if(this.Data.pic_text.length>0){
                   this.isShowName = true
                }
            } else {
                this.$message({
                    message: '暂无数据。。。',
                    type: 'error',
                    center: true
                })
                return
            }
        },
        getCarID (){
            const checkCar= this.Data.car_list.filter((item)=>{
                return item.car_name == this.carType
            })
            return checkCar[0].id
        },
        
        async onSubmit() {
            this.isValidataName =false;
            this.isValidataPhone =false;
            if(!this.name.trim()){
                this.isValidataName = true
                return
            }
            if(!this.phone.trim()){
                this.isValidataPhone = true
                return
            }
            const car_id = this.getCarID()
            const uid = window.localStorage.getItem('uid')
            const sumitObj = {
                action_id: this.initId,
                car_id,
                uname: this.name,
                tell: this.phone,
            }
            const result = await this.$http.signUp.h5baoming(sumitObj);
            if (result.code === 200) {
                window._agl && window._agl.push(['track', ['success', {t: 3}]])
                this.submitInfo = result.data;
                this.$message({
                    message: '报名成功！',
                    type: 'success',
                    center: true,
                    offset: 140
                })

            } else {
                this.$message({
                    message: result.msg,
                    type: 'error',
                    center: true,
                    offset: 140
                })
                return
            }
            // setTimeout(() => {

            //     this.$nextTick(() => {
            //         // this.$bus.$emit('submitInfo', this.submitInfo);
            //         if(this.submitInfo.order_num){
            //             this.$router.push(`/orderdetails/${this.submitInfo.order_num}`);
            //         }
                    
            //     })
            // }, 1000)

        },

    },
    
    async created(){
        const ID = this.$route.params.id;
        this.initId = this.$route.params.id;
         const result = await this.$http.goCatPreferential.getActionInfoByID({
            actionID: ID
        })
        this.getActionInfoData(result);
    }
}
</script>

<style lang="less">
    .enquiry-wrap .enquiry .enquiry-content .cartypes .el-select .el-input__inner {
        
        border: none;
    }
    .el-icon-arrow-up::before {
    font-size: 32px;
    }
    .enquiry-wrap .enquiry .enquiry-content .cartypes .el-select .el-input__inner {
        color: #131313;
        font-size: 40px  !important;
    } 
    .el-select-dropdown {
        height: 400px;
        position: fixed;
        bottom: 0 ;
        left: 0;
        .el-scrollbar{
            height: 100%;
            .el-select-dropdown__wrap{
                max-height: 100%;
            }
        }

    }
    .el-select-dropdown__list{
        .el-select-dropdown__item{
            height: 70px;
            line-height: 70px;
            font-size: 38px;
            font-weight: 400;
        }
    }
   .el-dialog{
       z-index: 999;
       background: #fff;
       width: 86vw  !important;
       min-height: 80vh;
       padding: 20px 30px 0;
       .dialog-header{
           height: 100px;
           line-height: 100px;
           font-size: 40px;
           color: #222;
           text-align: center;
           font-weight: 500;
           margin-bottom: 30px;
       }
       .dialog-content{
           h3{
               font-size: 36px;
               color: #333;
               font-weight: 600;
               margin-bottom: 30px;
           }
           p{
               font-size: 32px;
               color: #333;
               margin-bottom: 30px;
           }
       }
       .dialog-footer{
           text-align: center;
           .el-button{
               height: 100px;
               font-size: 40px;
               width: 400px;
               span{
                   color: #fff;
               }
           }
       }
   }            
    .enquiry-wrap{
        position: relative;

        .enquiry{
            margin-bottom: 300px;
            .enquiry-header{
                background: chocolate;
                img{
                    width: 100%;
                    object-fit: cover;
                }
            }
            .enquiry-content{
                padding: 0 40px;
                margin-top: 30px;
                .content-from{
                    .item{
                        margin-top: 20px;
                        .title{
                            height: 60px;
                            font-size: 40px;
                            line-height: 60px;
                                span{
                                    color: rgb(255, 68, 68);;
                                }
                            }
                        .input-item{
                            height: 70px;
                            input{
                                height: 100%;
                                width: 100%;
                                border-bottom: 1px solid #dcdcdc;
                                font-size: 36px;
                            }
                            
                        }
                        .validata{
                                color:red;
                                font-size: 28px;
                                display: block;
                                height: 34px;
                                line-height: 34px;
                                margin-bottom: 20px;
                            }
                        
                    }
                    .cartypes{
                        .el-select {
                            height: 80px;
                            width: 100%;
                            font-size: 34px;
                            .el-input__inner{
                                height: 80px;
                                font-size: 34px;
                                border-bottom:1px solid #dcdcdc ;
                            }
                            .el-input__suffix{
                                .el-select__caret{
                                    font-size: 40px;
                                    color: #000;
                                }
                            }
                        }
                        
                        
                    }
                        
                    .submit{
                        margin-top: 50px;
                        position: relative;
                        height: 90px;
                    .el-button{
                            width: 80vw;
                            height: 90px;
                            background-color: rgb(253, 0, 19);
                            border-radius: 50px;
                            color: #fff;
                            line-height: 40px;
                            font-weight: 550;
                            font-size: 48px;
                            position: absolute;
                            left: 50%;
                            top: 0;
                           transform: translateX(-50%);
                        }
                    }
                
                }
                
            }
            
        }

        .enquiry-footer{
                width: 100%;
                position: fixed;
                bottom: 0;
                left: 0;
                background: #fff;
                z-index: 10;
                .btn-wrap{
                    .el-button{
                        height: 90px;
                        width: 100%;
                        font-size: 38px;
                        margin-top: 20px;
                        margin-left: 0;
                        
                    }
                  
                }
                .statement{
                    text-align: center;
                    color: #999;
                    font-size: 28px;
                    margin-top: 20px;
                    span{
                        color:#4e90ff;
                    }
                }
            }
    }
</style>